import styled, { css } from 'styled-components'
import { TOP_BAR_HEIGHT } from 'components/ArcTopBar/constants'
import { ARC_PAGE_TOP_GAP, ARC_PAGE_TOP_GAP_MOBILE } from 'components/ArcPageShell/constants'

// Arc: the whole content block shifts below the fixed 60px top bar.
// `position: relative` turns the container into the containing block for the
// absolutely-positioned dashboard heroes, so they anchor at the bar's bottom
// edge instead of sliding under it.
//
// HIG rhythm (AR-578): the legacy top paddings (80/100) were sized to clear
// the legacy fixed Navbar; under Arc the bar is already cleared by the
// margin above, so keeping them doubled the offset. The Arc top padding is
// just the breathing gap between the bar and the page title, uniform on
// every Arc screen. `&&` outranks the legacy paddings declared below
// (including the media-query ones).
const arcTopBarOffset = css`
  position: relative;
  margin-top: ${TOP_BAR_HEIGHT}px;

  && {
    padding-top: ${ARC_PAGE_TOP_GAP}px;
  }
  @media only screen and (max-width: 800px) {
    && {
      padding-top: ${ARC_PAGE_TOP_GAP_MOBILE}px;
    }
  }
`

export const ContainerGlobal = styled.div<{ isApp: boolean; $arcTopBar?: boolean }>`
  max-width: 120rem;
  margin-left: auto;
  margin-right: auto;
  padding: 80px 40px 80px 120px;
  ${({ $arcTopBar }) => ($arcTopBar ? arcTopBarOffset : '')}

  @media only screen and (min-width: 800px) and (max-width: 1366px) {
    padding: 80px 40px 80px 120px;
  }
  @media only screen and (max-width: 800px) {
    padding: ${({ isApp }) => (isApp ? '0' : '100px 20px 80px 20px')};
  }

  @media (max-width: 680px) {
    .rodal-dialog {
      padding: 0;
    }
  }

  .__react_component_tooltip.show {
    max-width: 600px;
  }
`

export const ContainerNotification = styled.div`
  max-width: 60rem;
  margin-left: auto;
  margin-top: 2rem;
  position: fixed;
  right: 40px;
  z-index: 1000000;

  @media only screen and (max-width: 800px) {
    max-width: 40rem;
    right: 20px;
  }
`
